/**
 * This file is based on code from the placemark repository
 * (https://github.com/placemark/placemark), licensed under the MIT License.
 *
 * Modifications made by ACT Corp are proprietary
 */
import type { FileType } from ".";

export class CGeoTIFF implements FileType {
  id = "geotiff" as const;
  label = "GeoTIFF";
  extensions = [".tif", ".tiff"];
  filenames = [] as string[];
  mimes = [] as string[];
  /*
  forwardBinary(file: ArrayBuffer, _options?: ImportOptions) {
        const { getGeotiffExtent } = await import("vendor/geotiff");
        const extent = await getGeotiffExtent(file);
        return okResult(extent);
  }
  */
}

export const GeoTIFF = new CGeoTIFF();
